import { getCore } from '../../../client/core/getCore';
import type { DynamicClient } from '../../../client/types';
import { createApiClient } from '../../../modules/apiClient';
import { NONCE_POOL_EXPIRATION_TIME, NONCE_POOL_SIZE } from '../constants';

/**
 * Fetches a batch of nonces from the API.
 *
 * Prefetching is critical for iOS deep link wallet providers (e.g. Phantom
 * redirect). On iOS, a network request (like fetching a nonce) between a user
 * action and a deeplink call will break the gesture chain, causing iOS to
 * silently ignore the deeplink. By prefetching nonces ahead of time,
 * `getNonce` can return synchronously from cache and the deeplink fires
 * without an interrupting network round-trip.
 */
export const fetchAndStoreNonces = async (
  client: DynamicClient
): Promise<void> => {
  const core = getCore(client);

  const { environmentId } = core;

  const apiClient = createApiClient({}, client);

  const { nonces } = await apiClient.getNonces({
    count: NONCE_POOL_SIZE,
    environmentId,
  });

  core.state.set({
    prefetchedNonces: nonces,
    prefetchedNoncesExpiration: Date.now() + NONCE_POOL_EXPIRATION_TIME,
  });
};
